import * as yup from 'yup';

import { useYupValidators } from '~/utils/yupValidators';

const useGimacPaymentSchema = () => {
  const yupValidators = useYupValidators();
  const gimacPaymentSchema = yup.object().shape({
    phoneNumber: yupValidators.numberExpressUnion,
    indicatif: yupValidators.indicatifExpressUnion,
  });

  return { gimacPaymentSchema };
};

export { useGimacPaymentSchema };
